var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPingAp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    stroke: "#545454",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.159 6.677a1.333 1.333 0 1 0 1.507 1.322h2.667m2.666 0a6.667 6.667 0 1 1-3.333-5.774M13.999 8h-2.666m2.666 0h1.334m-4 0a4 4 0 1 1-2-3.464",
    stroke: "{stroke}",
    strokeWidth: 1.333,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPingAp);
export default __webpack_public_path__ + "static/media/ping_ap.115aa8843082dd6a2386f5ac27f43f97.svg";
export { ForwardRef as ReactComponent };